export default __webpack_public_path__ + "images/d151de908c762790190c3d87125a47a9-minus.svg";